import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledWrapAutocomplete,
  StyledAutoComplete,
  StyledWrapList,
  StyleList
} from './style';

const Autocomplete = props => {
  const onKeyPress = event => {
    if (event.which === 13) {
      props.onSave(event.currentTarget.value);
    } else if (event.which === 27) {
      props.changeEdit();
    }
  };

  return (
    <StyledWrapAutocomplete
      className={props.className}
      textInfo={props.textInfo}
    >
      <StyledAutoComplete
        onChange={props.onChange}
        onBlur={props.onBlur}
        name={props.name}
        onKeyDown={onKeyPress}
        errorMessage={props.errorMessage}
        value={props.value}
        id={props.id}
        autoFocus
      />

      <StyledWrapList>
        {props.list.map(item => (
          <StyleList
            key={item.id + new Date()}
            onClick={() => !props.readonly && props.onSelect(item)}
          >
            {item.name}
          </StyleList>
        ))}
      </StyledWrapList>
    </StyledWrapAutocomplete>
  );
};

Autocomplete.propTypes = {
  changeEdit: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string
    })
  ),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onSave: PropTypes.func,
  onSelect: PropTypes.func, //eslint-disable-line
  textInfo: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string
};

Autocomplete.defaultProps = {
  list: []
};

export default Autocomplete;
